import styled from 'styled-components';
import { COLORS } from 'Permafrost/constants';

export const StyledFilterSelectOptions = styled.ul`
  .option-container {
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${COLORS.oxfordBlue};
    cursor: pointer;

    .single-option,
    .multi-option {
      display: flex;
      padding: 0 0 var(--pf-padding-2) var(--pf-padding-3);
    }

    .option-checkbox {
      color: ${COLORS.baliHai};
      margin-right: var(--pf-padding-2);

      .checkboxSquare {
        stroke-width: 1;
      }

      &.checked {
        .checkboxSquare {
          color: var(--pf-secondary-color-400);
          fill: var(--pf-secondary-color-400);
        }

        .checkmark {
          color: ${COLORS.white};
        }
      }
    }

    .selected-checkmark {
      color: var(--pf-secondary-color-400);
      margin-left: var(--pf-padding-2);
    }
  }
`;
